import * as React from "react";
import {AlarmSeverity, AlarmStatus} from "../data/AlarmsMonitorData";
import {AlarmsMonitorDataMapper} from "../utils/AlarmsMonitorDataMapper";

const MAX_CIRCLE_HEIGHT = 120;
const MIN_CIRCLE_HEIGHT = 25;
const OUTER_CIRCLE_DIFFERENCE = 25;
const DOTS_HEIGHT = 20;
const MAX_ALARMS_COUNT_FOR_CIRCLE = 80;

interface AlarmMonitorCircleProps {
    alarmStatus: AlarmStatus;
    alarmSeverity: AlarmSeverity;
    maxValueInStatus: number;
    maxValueInSeverity: number;
    maxValuesInCategory: number;
    value: number;
    color: string;
    borderColor: string;
    index: number;
    maxHeightPx?: number;
    minHeightPX?: number;
    onClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
    openedAlarmSeverity: AlarmSeverity;
    isCategoryOpen: boolean;
}

export class AlarmMonitorCircle extends React.Component<AlarmMonitorCircleProps> {

    constructor(props) {
        super(props);
    }

    public render() {
        if (this.props.maxValueInSeverity == null || this.props.value == null || this.props.value === 0) {
            return null;
        }
        const height = this.props.isCategoryOpen ? DOTS_HEIGHT : this.calculateHeight();
        const outerStyle = {
            width: height + OUTER_CIRCLE_DIFFERENCE + "px",
            height: height + OUTER_CIRCLE_DIFFERENCE + "px",
        };
        const innerStyle = {
            width: height + "px",
            height: height + "px",
            backgroundColor: this.props.color,
        };
        const fontSize = height / this.getMaxHeight() * 3;
        const severityTextStyle = this.props.value < 100 && fontSize < 1 ? {fontSize: "1em", color: "white"}
            : {fontSize: fontSize + "em", color: "white"};
        if (this.props.alarmSeverity === AlarmSeverity.WARNING) {
            severityTextStyle.color = "rgb(137, 139, 137)";
        }
        let alarmCircleClasses = "alarm-circle";
        switch (this.props.alarmSeverity) {
            case AlarmSeverity.URGENT:
                alarmCircleClasses += " urgent-severity";
                break;
            case AlarmSeverity.HIGH:
                alarmCircleClasses += " high-severity";
                break;
            case AlarmSeverity.WARNING:
                alarmCircleClasses += " warning-severity";
                break;
            default:
                break;
        }

        if (this.props.openedAlarmSeverity === this.props.alarmSeverity) {
            alarmCircleClasses += " active";
        }
        return (
            <div className={"alarm-circle__container"}>
                {this.props.isCategoryOpen &&
                <p className={"circle-top-label"}>
                    {this.props.value}
                </p>
                }
                <div
                    className={alarmCircleClasses}
                    style={outerStyle}
                    onClick={this.props.onClick}
                    data-id={AlarmsMonitorDataMapper.toAlarmsSeverityGuid(this.props.alarmSeverity)}
                >
                    <div className={"alarm-circle__inner-circle"} style={innerStyle}>
                        {!this.props.isCategoryOpen &&
                        <p style={severityTextStyle}>
                            {this.props.value}
                        </p>
                        }
                    </div>
                </div>
            </div>
        );
    }

    private getMaxHeight() {
        if (this.props.maxHeightPx != null) {
            return this.props.maxHeightPx;
        }
        return MAX_CIRCLE_HEIGHT;
    }

    private calculateHeight() {
        const maxVal = this.getMaxHeight();
        let minVal = MIN_CIRCLE_HEIGHT;
        if (this.props.minHeightPX != null) {
            minVal = this.props.minHeightPX;
        }
        let val = null;
        if (this.props.value > MAX_ALARMS_COUNT_FOR_CIRCLE) {
            val = maxVal * 0.8;
            return val + (this.getMaxHeight() - val) * this.props.value / this.props.maxValueInStatus;
        }
        val = maxVal * 0.8 * this.props.value / MAX_ALARMS_COUNT_FOR_CIRCLE;
        if (val > maxVal) {
            val = maxVal;
        } else if (val < minVal) {
            val = minVal;
        }
        return val;
    }
}
